/* eslint-disable no-shadow */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
import FroalaEditor from "froala-editor";
import { i18n } from "@/i18n/index";
import icons from "../FroalaIcons";

const colorsArray = [
    "#cc4747",
    "#cc4774",
    "#cc47a0",
    "#cc47cc",
    "#a047cc",
    "#7447cc",
    "#4747cc",
    "#4774cc",
    "#47a0cc",
    "#47cccc",
    "#47cca0",
    "#47cc74",
    "#47cc47",
    "#74cc47",
    "#a0cc47",
    "#cccc47",
    "#cca047",
    "#cc7447"
];

Object.assign(FroalaEditor.POPUP_TEMPLATES, {
    "repeatableBlockPlugin.popup": "[_TITLE_]"
});

FroalaEditor.PLUGINS.repeatableBlockPlugin = function (editor) {
    let el;
    let color;
    let name;
    let uuid = "";
    let parentUuid = "";
    const coords = {
        top: 0,
        left: 0,
        offset: 0
    };

    function createBLock() {
        if (!editor.vueInstance.currentDoc.repeatableBlockCounter) {
            editor.vueInstance.currentDoc.repeatableBlockCounter = 0;
        }
        // eslint-disable-next-line no-multi-assign
        const counter = (editor.vueInstance.currentDoc.repeatableBlockCounter += 1);
        name = `Repeatable block ${counter}`;
        color = getRandomColor();
        const blockStart = `<div class="repeatable-block blkel" contenteditable="false" data-name="${name}" data-uuid="" data-parent-uuid="" data-color="${color}" style="border-color: ${color}; display: block"><section style="display: block" contenteditable="true" class="repeatable-inner">`;
        const blockEnd = '<dfn class="invisible" contenteditable="false" tabindex="-1" style="display: none">&nbsp;</dfn></section></div>';
        let content = "<p><br/></p>";
        const selectionBlocks = editor.selection.blocks().filter(ell => ell.localName !== "section");
        if (selectionBlocks.length > 1) {
            content = editor.html.getSelected();
            editor.selection.remove();
        }
        editor.html.insert(blockStart + content + blockEnd);
        showPopup();
    }

    function getRandomColor() {
        const index = Math.floor(Math.random() * colorsArray.length);
        return colorsArray[index];
    }

    function initPopup(fromNotif) {
        const popup = editor.popups.get("repeatableBlockPlugin.popup");
        if (popup) {
            popup.remove();
        }
        const template = createPopupTemplate();
        editor.popups.create("repeatableBlockPlugin.popup", template);
        editor.popups.setContainer("repeatableBlockPlugin.popup", editor.$("#doc-builder"));
        const blockMenu = editor.popups.get("repeatableBlockPlugin.popup");
        if (fromNotif) {
            blockMenu.attr("id", "repeatable-block-menu-notif");
        } else {
            blockMenu.attr("id", "repeatable-block-menu");
        }
        if (editor.$wp) {
            editor.$wp.off(`scroll.repeatableBlockPlugin.popup.ed${editor.id}`, scrollBlockMenu);
            editor.$wp.off(`scroll.repeatableBlockPlugin.popup.ed${editor.sid}`, scrollBlockMenu);
            editor.$wp[0]["data-events"] = [];
            editor.events.$on(editor.$wp, "scroll.repeatableBlockPlugin.popup", scrollBlockMenu);
        }
    }

    function scrollBlockMenu() {
        if (editor.popups.isVisible("repeatableBlockPlugin.popup")) {
            setPopupPosition();
            editor.popups.show("repeatableBlockPlugin.popup", coords.left, coords.top, coords.offset);
        }
    }

    function createPopupTemplate() {
        const settings = i18n.t("froala.settings");
        const deleteCondition = i18n.t("froala.delete");
        const addBefore = i18n.t("froala.addBefore");
        const addAfter = i18n.t("froala.addAfter");
        return {
            title: `<div class="repeatable-popup" style="background-color: ${color}"><span>${name}</span>
 <div style="display: inline" class="fr-btn"  data-title="${addBefore}">
                <svg class="fr-svg fr-command" data-cmd="lineBeforeRepeatable" viewBox="0 0 24 24" width="24px" height="24px">${icons.lineBefore}</svg>
                </div>
                <div style="display: inline" class="fr-btn"  data-title="${addAfter}">
                <svg class="fr-svg fr-command" data-cmd="lineAfterRepeatable" viewBox="0 0 24 24" width="24px" height="24px">${icons.lineAfter}</svg><span class="delimiter">|</span> </div>
                <div style="display: inline" class="fr-btn"  data-title="${settings}">
                <svg class="fr-svg fr-command" data-cmd="repBlockSettings" viewBox="0 0 24 24" width="24px" height="24px">${icons.settings}</svg><span class="delimiter">|</span>
                </div>
                 <div style="display: inline" class="fr-btn"  data-title="${deleteCondition}">
                <svg class="fr-svg fr-command" data-cmd="deleteRepeatableBlock" viewBox="0 0 24 24" width="24px" height="24px">${icons.delete}</svg></div></div>`
        };
    }

    function findRepeatableElement(clickEvent) {
        if (clickEvent) {
            el = editor.$(clickEvent.target);
        } else {
            el = editor.$(editor.selection.element());
        }
        if (!el.hasClass("repeatable-block")) {
            el = el.parentsUntil(editor.$el, ".repeatable-block").first();
        }
    }
    function showPopup(clickEvent, fromNotif) {
        findRepeatableElement(clickEvent);
        editor.vueInstance.disableSelection = false;
        if (!el.attr("data-parent-uuid")) {
            const repeatableBlockTree = el.parents(".repeatable-block");
            if (el.hasClass("repeatable-block") && repeatableBlockTree.length > 0) {
                el.attr("data-parent-uuid", repeatableBlockTree[0].getAttribute("data-uuid"));
                if (!el.attr("data-parent-uuid")) {
                    editor.vueInstance.disableSelection = true;
                } else {
                    checkParentSelection();
                }
            }
        } else {
            checkParentSelection();
        }
        color = el.attr("data-color");
        name = el.attr("data-name");
        uuid = el.attr("data-uuid");
        parentUuid = el.attr("data-parent-uuid");
        initPopup(fromNotif);
        checkBlockEmpty();
        setPopupPosition();
        el.addClass("selected");
        if (!editor.popups.isVisible("table.edit")) {
            editor.popups.show("repeatableBlockPlugin.popup", coords.left, coords.top, coords.offset);
        } else {
            editor.popups.show("repeatableBlockPlugin.popup", coords.left, coords.top, coords.offset);
            editor.popups.show("table.edit");
        }
        editor.popups.onHide("repeatableBlockPlugin.popup", () => {
            el.removeClass("selected");
        });
    }
    function checkParentSelection() {
        const parent = editor.vueInstance.currentDoc.repeatableParameters.find(block => block.uuid === el.attr("data-parent-uuid"));
        if (!parent.selection.length) {
            editor.vueInstance.disableSelection = true;
        }
    }

    function clickBlock(clickEvent) {
        findRepeatableElement(clickEvent);
        editor.events.trigger("updateRepeatableBlock", [el.attr("data-name"), el.attr("data-uuid"), el.attr("data-parent-uuid")]);
    }

    function checkBlockEmpty() {
        let content;
        if (el.hasClass("blkel")) {
            content = `<section style="display: block" contenteditable="true" class="repeatable-inner"><p>${FroalaEditor.MARKERS}<br/></p><dfn class="invisible" contenteditable="false" tabindex="-1" style="display: none">&nbsp;</dfn></section>`;
        }
        if (el.contents().length === 0) {
            el.html(content);
        } else if (el.contents().length === 1) {
            if (
                el.find(".repeatable-inner").contents().length === 0
                || (el.find(".repeatable-inner").contents().length === 1
                    && el
                        .find(".repeatable-inner")
                        .children()
                        .first()
                        .hasClass("invisible"))
            ) {
                el.html(content);
                editor.selection.restore();
                editor.toolbar.enable();
            }
        }
    }

    function setVisible(fromNotif) {
        el.addClass("selected");
        if (fromNotif) {
            editor.$("#repeatable-block-menu-notif").addClass("fr-active");
        } else {
            editor.$("#repeatable-block-menu").addClass("fr-active");
        }
    }

    function setPopupPosition() {
        coords.left = el.offset().left;
        coords.top = el.offset().top - 50;
        coords.offset = 0;
    }

    function openSettings() {
        editor.vueInstance.openRepeatableBlockSettings({ name, uuid, parentUuid });
    }
    function hidePopup() {
        editor.popups.hide("repeatableBlockPlugin.popup");
    }

    function applySettings({ name = "", uuid = "" } = {}) {
        el.attr("data-name", name);
        el.attr("data-uuid", uuid);
        editor.events.trigger("contentChanged", ["fromBlock"]);
        hidePopup();
    }

    function removeBlock() {
        const { $ } = editor;
        el.attr("contenteditable", "true");
        const inner = el
            .children()
            .get()
            .reverse();
        let acumulator = "";
        inner.forEach(element => {
            if ($(element).hasClass("repeatable-inner")) {
                $(element)
                    .find(".invisible")
                    .remove();
                acumulator += $(element).html();
            } else {
                acumulator += element.outerHTML;
            }
        });
        el.replaceWith(acumulator);
    }

    function deleteBlockAndContent() {
        editor.vueInstance.deleteRepeatableConfig(uuid);
        el.remove();
        hidePopup();
    }

    function insertLine(before) {
        const line = "<p><br/></p>";
        editor.popups.hideAll();
        if (before) {
            el.before(line);
        } else {
            el.after(line);
        }
    }

    return {
        createBLock,
        showPopup,
        setVisible,
        hidePopup,
        openSettings,
        applySettings,
        removeBlock,
        deleteBlockAndContent,
        clickBlock,
        insertLine
    };
};
FroalaEditor.DefineIcon("repeatableBlock", { template: "textSVG", PATH: icons.repeatableBlock, NAME: i18n.t("froala.repeatableBlock") });
FroalaEditor.RegisterCommand("repeatableBlock", {
    title: i18n.t("froala.repeatableBlockTooltip"),
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    refresh($btn) {
        if ((this.vueInstance.editMode !== "template" && !this.vueInstance.configNotifications) || this.vueInstance.disableButton.repeatableBlock) {
            $btn.addClass("fr-disabled");
        } else {
            $btn.removeClass("fr-disabled");
        }
    },
    callback() {
        this.repeatableBlockPlugin.createBLock();
    },
    plugin: "repeatableBlockPlugin"
});

FroalaEditor.RegisterCommand("repBlockSettings", {
    title: null,
    undo: false,
    focus: true,
    callback() {
        this.repeatableBlockPlugin.openSettings();
    },
    plugin: "repeatableBlockPlugin"
});

FroalaEditor.RegisterCommand("deleteRepeatableBlock", {
    title: null,
    undo: true,
    focus: true,
    callback() {
        this.repeatableBlockPlugin.deleteBlockAndContent();
    },
    plugin: "repeatableBlockPlugin"
});

FroalaEditor.RegisterCommand("lineBeforeRepeatable", {
    title: null,
    undo: true,
    focus: false,
    callback() {
        this.repeatableBlockPlugin.insertLine(true);
    },
    plugin: "repeatableBlockPlugin"
});

FroalaEditor.RegisterCommand("lineAfterRepeatable", {
    title: null,
    undo: true,
    focus: false,
    callback() {
        this.repeatableBlockPlugin.insertLine(false);
    },
    plugin: "repeatableBlockPlugin"
});
